/**
 * Form Referer Handler
 *
 * Captures referer from URL query string and adds it to form hidden field
 * Usage: x-data="formReferer"
 *
 * Features:
 * - Reads 'ref' or 'referer' from URL query params
 * - Adds hidden input to form with name "fields[referer]"
 * - Works with Formie forms
 * - Reusable across multiple forms
 */

export default () => ({
    referer: '',
    formId: '',

    init() {
        // Get referer from URL query string
        this.referer = this.getRefererFromURL();

        // Get form ID from the form element
        const form = this.$el.querySelector('form');
        if (form) {
            this.formId = form.id || '';
        }

        // Add hidden input after form is loaded
        this.$nextTick(() => {
            this.addRefererField();
        });
    },

    // Extract referer from URL query parameters
    getRefererFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('ref') || urlParams.get('referer') || '';
    },

    // Add value to existing hidden input field
    addRefererField() {
        if (!this.referer) {
            return;
        }

        const form = this.$el.querySelector('form');
        if (!form) {
            console.warn('Form not found in formReferer component');
            return;
        }

        // Find existing hidden input field
        const existingField = form.querySelector('input[name="fields[referer]"]');
        if (existingField) {
            existingField.value = this.referer;
            // console.log(`Referer value set to form ${this.formId}:`, this.referer);
        } else {
            // console.warn(`Hidden field "fields[referer]" not found in form ${this.formId}. Please add it to your form.`);
        }
    },

    // Method to manually update referer if needed
    updateReferer(newReferer) {
        this.referer = newReferer;
        this.addRefererField();
    }
});
